// Home page featured product image gallery
$( document ).ready(function() {
$( "ul li.product__media-item" ).find( ".product__media-toggle" ).on('click', function(){
  let flkty = new Flickity(".carousel-main");
  flkty.focus();
// $(".carousel-main").flickity();
        var index = $(".product__media-toggle").index(this);
        $('.carousel-main').flickity( 'select', index ); 
    $('.carousel-nav').flickity( 'select', index ); 
});
}); 

/* genrate random No **/
  let r = (Math.random() + 1).toString(36).substring(2);
  if($('.mainP_random').length > 0){
    $('.mainP_random').val(r);
  }

$(document).on("click",".product_scoller",function() {       
          $('html, body').animate({ scrollTop: $(".featured-product").offset().top  }, 2000); 
        });
$('.customer_reviews .Svgicons').click(function(){
    $('html, body').animate({ scrollTop: $(".Review-heading").offset().top  }, 2000); 
})
$(document).on("click",".know_more",function(event) {
  event.preventDefault();
          $('html, body').animate({ scrollTop: $(".how-it-work-content").offset().top  }, 2000); 
        });

$(document).on("click",".product_close_icon",function() {
  $('.sticky_add_to_cart').hide();
})

$(document).on("click",".customer_video_play",function() {
    var video = $(this).parents('.cstm_video').find(".customer_video");
  var v_url = $(this).parents('.cstm_video').find('.image_video video').attr('data-src');
  if($(this).parents('.cstm_video').find('.image_video video source').attr('src') == ''){
   $(this).parents('.cstm_video').find('.image_video video source').attr('src',v_url);
   }
  $('.customer_video_play').removeClass('video-playing');  
  $(this).parents('.cstm_video').find('.author_image').hide();
   $(this).parents('.cstm_video').find('.image_video').show();
    var videoall = $(".customer_video");
if (isNaN(video[0].duration)) {
    $(video)[0].load();
}
    if (video.get(0).paused) {
     $(this).addClass('video-playing');
        video.get(0).play();
      
        videoall.not(video).each(function() {
            this.pause();         
        });
    } else {
       $(this).removeClass('video-playing');
        video.get(0).pause();
    }
});

$(document).on("click",".subscription_button",function() {
  
   $('html, body').animate({ scrollTop: $(".product__description").offset().top  }, 500); 
});
$(document).on("click",".sticky-cart",function() {
 
  $('html, body').animate({ scrollTop: $(".product__description").offset().top  }, 500);
});

 if (window.matchMedia("(max-width: 749px)").matches){
 jQuery(document).ready(function(){
    jQuery('.customer_reviews_main').flickity({
    groupCells: true,
    groupCells: 1
      });
});
  }

$(document).on('click', '.header a[href^="#"]', function (event) {
   event.preventDefault();
    $('html, body').animate({ scrollTop: $($.attr(this, 'href')).offset().top }, 3000);
  $('body').removeClass('overflow-hidden-tablet');
  $('.menu-drawer-container').removeClass('menu-opening');
  $('.menu-drawer-container').removeAttr('open');
  $('header-drawer .header__icon').attr('aria-expanded',false)
});


// $(document).on("click",'.featured-product .subscription_product input[type="radio"]',function() {
//   $('.subscription_product').removeClass('active');
// $(this).parents('.subscription_product').addClass('active');
//   var valueOption = $(this).attr('value');
//   var DataPrice = $(this).parents('.subscription_product').find('.sub_price').text();
// if(valueOption == '' ){
//   $('.featured-product .subscriptionP').attr('disabled',true);
//  $('.featured-product .product-variant-id').attr('disabled',true);
//   $('.featured-product .without_subscription').attr('disabled',false);  
//   $('.featured-product .with_subscription').attr('disabled',true);
// }else{
//  $('.featured-product .subscriptionP').attr('disabled',false);
//  $('.featured-product .product-variant-id').attr('disabled',false);
//   $('.featured-product .without_subscription').attr('disabled',true);  
//   $('.featured-product .with_subscription').attr('disabled',false);
// }
//   $('span.price_value').text(DataPrice)
// })
$(document).on("click",'.featured-product .subscription_product input[type="radio"]',function() {
  var valueOption = $(this).attr('value');
if(valueOption == '' ){
  $(this).parents('.product-form').find('input[name="properties[Delivery]"]').attr('disabled',true)
}else{
    $(this).parents('.product-form').find('input[name="properties[Delivery]"]').attr('disabled',false)
}
});
               
$(document).on("click",'.wrapper_subscription  input[type="radio"]',function() {
  var valueOption = $(this).attr('value');
  if( valueOption != ''){
$('.product_list_subscription').attr('disabled',false);
  }else
  {
   $('.product_list_subscription').attr('disabled',true);
  }
});
$(document).on("change",'.featured-product .subscription_drop_down select',function() {
  var selectedOptionValue = $(this).find("option:selected").attr('subscription-months');
  var ProductPrice = $('.addition_sub_product').attr('data-price-val'); 
 $('.addition_sub_product').val('Subscription: Bottle billed & Delivered  every '+selectedOptionValue+' at '+ProductPrice+', starting '+selectedOptionValue+' after receiving your Washup kit');
})

$(document).on("change",'.suvscription_list_items',function() {
  var selectedOptionValue = $(this).find("option:selected").attr('subscription-months');
  var ProductPrice = $('.product_list_subscription').attr('data-price-val1');
 $('.product_list_subscription').val('Delivered & billed every '+selectedOptionValue+' at '+ProductPrice+', starting '+selectedOptionValue+' after receiving your Washup kit');
})

 // setTimeout(function(){  
 //   $(".featured-product .product-variant-id").attr('disabled',true);
 // },1000)

document.addEventListener("DOMContentLoaded",()=>{const reviewCount=document.querySelector(".custom-reviews-jtpl")?.dataset.reviews;if(!reviewCount)return;const observer=new MutationObserver(()=>{const count=document.querySelector(".oke-w-reviews-controls .oke-w-reviews-count");count&&count.textContent!==reviewCount&&(count.textContent=reviewCount)});observer.observe(document.body,{childList:!0,subtree:!0,characterData:!0}),setTimeout(()=>observer.disconnect(),5e3)}),document.addEventListener("DOMContentLoaded",function(){const reviewTrigger=document.querySelector(".custom-reviews-jtpl");reviewTrigger&&reviewTrigger.addEventListener("click",function(e){e.preventDefault();const reviewsSection=document.querySelector(".oke-w-reviewsTab");reviewsSection&&reviewsSection.scrollIntoView({behavior:"smooth",block:"start"})})});